import { useHomeRedirect } from '@suntex.fim/nav'

/**
 * returns JSX for home
 */
function Home() {
  useHomeRedirect()

  return <></>
}

export default Home
